<template>
    <div class="par_wrap">
        <p class="back_box" @click="back()">
          <img src="../../../static/images/back.png" alt="">
          返回上一页</p>
        <div class="box">
            <h2>查看并操作</h2>
            <ParheaderVue :caseid="caseid" :token="token"/>
            <div class="swi_box">
                <!--<div class="top_box">
                    <p>
                        <router-link :to="{name:parinfArray[usertype],params:{token:token},query: {caseid:this.caseid}}">出险信息</router-link>
                        <router-link :to="{name :parcaseArray[usertype],params:{token:token},query: {caseid:this.caseid}}">案件进展</router-link>
                    </p>
                </div>-->
                <div class="bottom_box">
                    <router-view></router-view>
                </div>
            </div>
            <div class="jiedianBox">
				<div class="det_box">
					<p v-for="(v,ind) in stepdata" :key="ind" v-if="v.dict.parentId===0">
						<b>{{v.dict.name}}救援服务清单</b>
					</p>
				</div>
				<div class="list" v-for="(item,index) in stepdata" v-if="index != 0">
					<div class="yes">
						<div class="top">
							<p class="icon">{{item.dict.name}}</p>
						</div>	
						<div class="box1">
							<p>其他节点：</p>
							<ul>
								<li v-for="(item,index) in item.solutionSvrPointList">{{index + 1}}、{{item.description}}</li>
							</ul>
						</div>
						<div class="box1">
							<p>操作说明：</p>
							<ul>
								<li>{{item.obj.description}}</li>
							</ul>
						</div>
						<div class="box1">
							<p>相关单据：</p>
							<ul class="addfujian">
								<li v-for="item in imglist[index - 1].list"  v-if="item.url">
									<span>{{item.description || 'no name'}}</span> <a :href="item.url" class="delete" :download='item.url' target="_blank">[下载]</a>									
								</li>
							</ul>
						</div>
					</div>
				</div>				
			</div>
			<div class="baojia">
				<p><b>救援报价</b></p>
				<ul>
					<h3>A、报价</h3>					
					<h3>整体报价: <span>{{moneyAll1.totalFee || ''}} {{moneyAll1.currency || 'USD'}}</span></h3>
					<li>救援费用: <span>{{moneyAll1.rescueFee}} {{moneyAll1.currency || 'USD'}}</span></li>
					<li>案件费用: <span>{{moneyAll1.caseFee}} {{moneyAll1.currency || 'USD'}}</span></li>
					<li>医疗费用: <span>{{moneyAll1.medicFee}} {{moneyAll1.currency || 'USD'}}</span></li>
					
				</ul>
				<ul>
					<h3>B、实际费用</h3>
					<h3>整体报价: <span>{{moneyAll2.totalFee || ''}} {{moneyAll2.currency || 'USD'}}</span></h3>
					<li>救援费用: <span>{{moneyAll2.rescueFee}} {{moneyAll2.currency || 'USD'}}</span></li>
					<li>案件费用: <span>{{moneyAll2.caseFee}} {{moneyAll2.currency || 'USD'}}</span></li>
					<li>医疗费用: <span>{{moneyAll2.medicFee}} {{moneyAll2.currency || 'USD'}}</span></li>					
					<li>其他费用: <span>{{moneyAll2.otherFee}} {{moneyAll1.currency || 'USD'}}</span></li>
				</ul>
				<p class="text1"><b>费用备注：</b>{{moneyAll2.otherFeeDesc}}</p>
			</div>
        </div>
    </div>
</template>

<script>
import "isomorphic-fetch";
import constants from '@/util/constants.js';
import Promise from 'promise-polyfill';
import ParheaderVue from "../par/parheader.vue";
import { getCasedetail,getNodeData } from '@/views/axios/api.js';
if (!window.Promise) {
  window.Promise = Promise;
}
export default {
  components: {
    ParheaderVue
  },
  data() {
    return {
      token: this.$route.params.token||
        JSON.parse(window.localStorage.getItem("data")).data,
      obj: {},
      victimList: {},
      inf: null,
      init: null,
      obj2: null,
      typeId:this.$route.query.typeId,
      caseid:this.$route.query.caseid,
      usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
      finishArray:["Finish","ComFinish","RegFinish"],
      parinfArray:["Finishparinf","ComFinishparinf","RegFinishparinf"],
      parcaseArray:["Finishparcase","ComFinishparcase","RegFinishparcase"],
      stepdata:[],
      serviceFinish:'',
      num:'',
      imglist:[],
      moneyAll1:{},
      moneyAll2:{},
    };
  },
  methods: {
    back() {
      this.$router.go(-2)
    },
    up(v) {
      console.log(v);
    },
    setdata() {
      let that = this;
      that.$router.push({
        name: that.parinfArray[that.usertype],
        params: {
          token: that.token
        },
        query: {
          caseid:this.caseid,
          typeId: this.$route.query.typeId
        }
      });
    },
    getCasedetail(){
    	var data={
			token:this.token,
			caseId:this.caseid
    	}
    	getCasedetail(data)
	      .then(data => {
	      	data=data.data
	        this.init = data.obj;
	        this.obj2 = data.obj2;
	        this.moneyAll2 =data.obj.obj
	        this.setdata();
	      })
	      .catch(err => {
	      	console.log(err)
	      })
    	
    },
	getNodeData(){
		var data={
			token: this.token,
			caseId: this.caseid					
		}
		getNodeData(data)
		.then(res => {
			this.stepdata = res.data.obj2;
			this.moneyAll1 = res.data.obj;
			let n = 0;
			let arr = [];
			this.stepdata.map((v, i) => {
				arr.push(v.obj.state);
				if(v.dict.parentId != 0) {
					if(v.obj.state && v.obj.state == 1) {
						this.stid = i;
						console.log(v.obj.state);
					} else {
						this.serviceFinish = 0;
					}
				}
				if(i != 0) {
					this.imglist.push({
						list: v.uploadCntList
					});
					if(v.uploadCntList.length > 0) {
						this.num = i;
					}
				}
			});
			for(let index = 0; index < arr.length; index++) {
				if(arr[index] != 0) {} else {
					n = index + 1;
				}
			}
			if(n == 0) {
				this.btn_flag = true;
			}
			this.loading = false;
		});				
	},    
  },
  mounted() {
    this.getCasedetail();
    this.getNodeData()
  }
};
</script>

<style scoped>
@import url(../../css/par.css);
.case_box{padding-left: 35px;}
	.jiedianBox{margin-top: 10px;}
	.jiedianBox .list{margin-bottom: 20px;margin-left: 40px;}
	.jiedianBox .list .top{overflow: hidden;}
	.jiedianBox .list .top p{float: left;margin-right: 200px;}
	.jiedianBox .list .top p.text1{color: #00abfa;margin-right: 0;margin-left: 20px;cursor: pointer;}
	.jiedianBox .list .top p.icon{background: url('./../../assets/img/checkyes.png') left center no-repeat;padding-left: 20px;}
	.jiedianBox .list .top p.iconNo{background: url('./../../assets/img/checkno.png') left center no-repeat;padding-left: 23px;}
	.jiedianBox .list .box1{margin-top: 10px;margin-left: 30px;overflow: hidden;}
	.jiedianBox .list .box1 ul{float: left;color: #999;}
	.jiedianBox .list .box1 p{float: left;line-height: 30px;}
	.jiedianBox .list .box1 li{line-height: 30px;}
	.det_box{margin-bottom: 20px;}
.addfujian li{
	background: url('../../../static/images/fj.png') no-repeat left center;
	padding-left: 20px;	
	cursor: pointer;
	margin-bottom: 10px;
	line-height: 30px;
	margin-right: 150px;
	
}
.addfujian li span{
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: inline-block;
	vertical-align: middle;	
}
.addfujian li.add{color: #00abfa;}
.addfujian li .delete{color: #00abfa;margin-left: 10px;text-decoration: none;}	
.baojia{padding-left: 35px;}
.baojia ul{overflow: hidden;margin-top: 20px;margin-left: 40px;}
.baojia ul *{float: left;margin-right: 10px;}
.baojia ul h3{font-size: 14px;}
.baojia ul h3:first-child{width: 90px;}
.baojia ul span{color: #ff7200;float: none;}
.baojia ul li{font-size: 14px}
.text1{margin-top: 20px;;margin-left: 140px;color: #333;font-size: 14px;}
</style>


// WEBPACK FOOTER //
// src/components/finish/finishpar.vue